<template>
<div class="chapter">
<div class="inner_page">
<p class="indenti"> </p>
<p class="image"><img alt="image" class="img1" src="images/title.jpg"/></p>
<p class="author">FRANCES WILSON</p>
<p class="publisher">FARRAR, STRAUS AND GIROUX<br/>NEW YORK</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1fcbe706